import styled from "styled-components";

export const TaskImgPageContentLayout = styled.div`
  position: relative;
  display: grid;
  height: calc(100vh - 56px);
  grid-template-rows: 50px auto 86px;
`;

export const TaskImgPageContentHead = styled.div`
  display: flex;
  padding: 0 16px;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
`;

export const TaskImgCountBox = styled.span`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${(props) => props.theme.colors.primary};
`;

export const TaskImgButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

export const TaskImgButton = styled.div`
  display: flex;
  height: 36px;
  padding: 0 12px;
  color: ${(props) => props.theme.colors.tagBg};
  font-size: 1.5rem;
  border: 1px solid ${(props) => props.theme.colors.tagBg};
  border-radius: 6px;
  background: ${(props) => props.theme.colors.white};
  align-items: center;

  &.primary {
    border: 1px solid ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.primary};
  }

  &.red {
    border: 1px solid ${(props) => props.theme.colors.red};
    color: ${(props) => props.theme.colors.red};
  }

  &.disabledColor {
    border: 1px solid ${(props) => props.theme.colors.inputBorder};
    color: ${(props) => props.theme.colors.inputBorder};
  }
`;

export const TaskImgPageContentBody = styled.div`
  overflow: auto;
  display: flex;
  height: 100%;
  flex-direction: column;
  gap: 12px;

  input {
    display: none;
  }
`;

export const TaskImgPageContentBodyBox = styled.div`
  display: flex;
  padding: 20px 16px;
  background: ${(props) => props.theme.colors.white};
  flex-direction: column;
  gap: 16px;
`;

export const TaskImgUploadsDate = styled.p`
  font-size: 1.6rem;
  font-weight: 600;
`;

export const TaskImgUploadsBox = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;

  input {
    display: none;
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 6px;
  gap: 7px;

  & > div {
    display: flex;
    font-size: 1.1rem;
    font-weight: 500;
    color: ${(props) => props.theme.colors.labelTxt};
    align-items: center;
    gap: 2px;
  }
`;

export const SelectedImg = styled.div`
  display: flex;
  width: 100%;
  height: 120px;
  position: absolute;
  background: ${(props) => props.theme.colors.white}6F;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 20 !important;

  svg {
    width: 30px;
    height: 30px;
  }
`;

export const ImgBox = styled.div`
  width: 100%;
  height: 120px;
  background: ${(props) => props.theme.colors.mainBg};
  border-radius: 6px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 6px;
  }
`;

export const TaskImgPageContentBottomBox = styled.div`
  display: flex;
  width: 100%;
  padding: 0 16px;
  align-items: center;
  flex-direction: row;
  gap: 6px;

  .small {
    width: 40%;
  }
`;

export const TaskImgBigModal = styled.div`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: ${(props) => props.theme.colors.black}b2;
  z-index: 9998 !important;
`;

export const TaskImgBigModalLayout = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const TaskImgBigModalBox = styled.div`
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const CloseButton = styled.div`
  position: absolute;
  border-radius: 100%;
  background: ${(props) => props.theme.colors.white}6F;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  top: 6%;
  right: 3%;
`;
